<template>
  <div class="bq-banner" :class="classes">
    <div
      class="bq-banner-cover"
      :style="{ backgroundImage: `url(${cover})` }"
      v-if="!isMobile"
    />

    <!-- mobile 适配 -->
    <img class="bq-banner-cover" :src="mcover" :alt="title" v-if="isMobile" />

    <!-- 标题扩展 -->
    <h2 class="bq-banner-title" v-if="title">{{ title }}</h2>

    <!-- content 扩展 -->
    <slot name="content"></slot>

    <!-- extra 扩展 -->
    <slot name="extra"></slot>
  </div>
</template>

<script>
// import { isWirelessDevice } from '../../utils/utils';

export default {
  name: 'BQBanner',

  props: {
    type: {
      type: String,
      default: 'vertical', // horizontal || vertical
    },
    cover: {
      type: String,
      required: true,
    },
    mcover: String,
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isMobile: false,
    };
  },

  created() {
    // this.isMobile = isWirelessDevice();
  },

  computed: {
    classes() {
      const { type, isMobile } = this;

      return {
        [`bq-banner-${type}`]: type,
        mobile: isMobile,
      };
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
